<template>
  <vertical-modal
    width="tn"
    :visible="props.visible"
    @close="close"
    body-class="tw-overflow-y-auto"
    header-title="مرحله تایید پرداخت"
  >
    <template #body>
      <div
        class="tw-flex tw-justify-around tw-items-center tw-pt-14"
        v-if="send_verify_code_loading"
      >
        <loading-spinner :show="true" class="tw-text-blue-dark-200" />
      </div>
      <template v-else-if="verification_data">
        <div class="tw-border-b tw-border-dashed tw-border-blue-dark-50 tw-text-blue-dark-500 tw-py-4 tw-px-5">
          <p class="tw-mb-4 tw-font-bold tw-text-base">مبلغ درحال پرداخت</p>
          <div>
            <base-icon
              icon="universal-currency"
              class="tw-align-middle tw-ml-4"
            />
            <span class="tw-inline-block">
              {{ toNumberFormat(verification_data.amount) }} ریال
            </span>
          </div>
        </div>
        <div class="tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-300 tw-p-4 tw-px-5">
          <p class="tw-mb-3">
            {{ verification_data.dest_bank.bank_name || 'نام بانک' }} |
            {{ verification_data.dest_bank.owner_name }}
          </p>
          <p class="tw-mb-3">
            {{ verification_data.dest_bank.shaba_num }}
          </p>
          <p class="">
            {{ verification_data.transfer_type }}
          </p>
        </div>
        <div
          class="tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-300 tw-pt-8 tw-px-5"
        >
          <p class="tw-mb-5">
            <base-icon icon="send-to-mobile" class="tw-ml-2" />
            کد برای شماره
            <span class="tw-inline-block ltr">{{
              verification_data.mobile
            }}</span>
            ارسال شد.
          </p>

          <input-ayandeh
            v-model:value="verification_code"
            placeholder="کد تایید را وارد کنید"
            base-icon="key"
            label-class="tw-mb-3"
            :label="'کد تایید'"
            class="tw-text-right"
            dir="ltr"
          />
        </div>
      </template>
    </template>

    <template #footer>
      <new-btn
        variant="outline"
        color="primary"
        :border="false"
        :disabled="verification_loading"
        @click="close"
        >بستن
      </new-btn>
      <new-btn
        variant="outline"
        color="primary"
        :disabled="verification_loading || verification_code.length < 5"
        :loading="verification_loading"
        @click="confirmed"
      >
        <base-icon icon="check-circle" class="tw-ml-2 tw-align-middle" />
        تایید کد
      </new-btn>
    </template>
  </vertical-modal>
</template>

<script setup>
import { defineProps, watch, defineEmits } from 'vue'
import VerticalModal from '@/components/base/VerticalModal.vue'
import InputAyandeh from '@/components/inputs/InputAyandeh.vue'
import { getCurrentInstance, onMounted, ref } from 'vue'
import BaseIcon from '@/components/base/BaseIcon.vue'
import NewBtn from '@/components/base/btn/NewBtn.vue'
import LoadingSpinner from '@/components/loading/LoadingSpinner.vue'
import {apiCancelPaymentAble, apiSendVerificationCode} from '@/services/paymentable/PaymentAble'
import Swal from 'sweetalert2'

const props = defineProps({
  payment_able: { type: Object, default: null },
  visible: { type: Boolean, default: false },
  amount_pay: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['close', 'confirmed'])

const { proxy } = getCurrentInstance()
const verification_loading = ref(false)
const send_verify_code_loading = ref(false)
const verification_data = ref(null)
const verification_code = ref('')

// onMounted(() => {
//
// })
const close = () => {
  emit('close', true)
}
const resetModalData = () => {
  verification_data.value = null
  verification_code.value = ''
}

watch(
  () => props.visible,
  (newVal) => {
    if (newVal) {
      sendVerificationCode()
    } else {
      resetModalData()
    }
  },
)

const sendVerificationCode = async (params = {}) => {
  send_verify_code_loading.value = true
  try {
    const response = await apiSendVerificationCode({
      payment_able_id: props.payment_able.id,
      amount_paymentable: props.amount_pay,
      ...params,
    })
    if (!response) return

    if (response.status === 202 && response.data?.confirm_type === 'mismatch') {
      await showNameMismatchAlert(response.data.message)
      return
    }
    verification_data.value = response.data
  } catch (error) {
    console.log(error)
    close()
  } finally {
    send_verify_code_loading.value = false
  }
}

const confirmed = () => {
  emit('confirmed', verification_code.value)
  close()
}


const showNameMismatchAlert = async (text, ) => {
  proxy.$showConfirm(
    {
      title: 'عدم مطابقت',
      confirm_text: 'تایید میکنم',
      text: text,
      icon: 'warning',
    },
    () => {
      sendVerificationCode({ confirmed: 'mismatch' })
    }
  )
}
</script>

<style scoped></style>
